export enum COMMON_ACTION_TYPE {
  LIST = 'common/list',
  INQUIRY = 'common/inquiry',
  INIT = 'common/init',
  SWITCH_COMPANY = 'common/switch_company',
  GET_QUIZ = 'common/quiz',
  POST_QUIZ = 'common/quiz_post',
  SET_INIT_POSITION = 'common/init_position',
  SET_INIT_TAGS = 'common/init_tags',
  SURVEY = 'common/survey',
}
